// Real, external destinations per ARDC's RAiD domain/service guide - not
// this app's own routes. Shared between the header nav links and the
// footer quick-links so both surfaces point at the same URLs.
export const EXTERNAL_LINKS = {
    ABOUT_RAID: "https://ardc.edu.au/services/ardc-identifier-services/raid-research-activity-identifier-service/",
    DOCUMENTATION: "https://documentation.ardc.edu.au/raid",
    RAID_ORG: "https://raid.org",
    SCHEMA_DOCUMENTATION: "https://metadata.raid.org/",
    REQUEST_SUPPORT: "mailto:contact@raid.org",
    CONTACT_ARDC: "mailto:services@ardc.edu.au",
}
